import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Route, Switch, useHistory } from "react-router-dom";
import PrivateRoute from "../PrivateRoute";

import Layout from "../components/Layout";

import Empleos from "../pages/Applicant/Empleos";
import Vacante from "../pages/Applicant/Vacante";
import PerfilEmpresa from "../pages/Applicant/PerfilEmpresa";
import Conecta from "../pages/Applicant/Conecta";
import Aplicados from "../pages/Applicant/Aplicados";
import Guardados from "../pages/Applicant/Guardados";
import Perfil from "../pages/Applicant/Perfil";
import Home from "../pages/Applicant/Home";
import Formacion from "../pages/Applicant/HomeFormacion";

import WrapperVacante from "../layout/WrapperVacante";
import WrapperCursos from "../layout/WrapperCursos";
import DetalleCurso from "../pages/CentroFormacion/DetalleCurso";
import DetalleCursoAplic from "../pages/Applicant/DetalleCurso";

import PerfilEmpresaEdit from "../pages/Company/PerfilEmpresaEdit";
import Candidato from "../pages/Company/Candidato";
import ConectaEmpresa from "../pages/Company/Conecta";
import DetailVacant from "../pages/Company/DetailVacant";
import HomeEmpresas from "../pages/Company/Home";
import VistaVacante from "../pages/Company/VistaVacante";
import Perfilempresa from "../pages/Company/PerfilEmpresa";
import Talento from "../pages/Company/Talento";

import PerfilCentroEdit from "../pages/CentroFormacion/PerfilCentro";
import VistaVacanteCentro from "../pages/CentroFormacion/VistaVacante";
import CandidatoCentro from "../pages/CentroFormacion/Candidato";
import PerfilEmpresaCentro from "../pages/CentroFormacion/PerfilEmpresa";

import BusquedaEmpleos from "../pages/Applicant/BusquedaEmpleos";
import HomeCentro from "../pages/CentroFormacion/Home";
import useOnceEffect from "../Hooks/useOnceEffect";
import ChatPage from "../components/ChatPage/ChatPage";
import AdminHome from "../components/Admin/AdminHome";
import useRoles from "../Hooks/useRoles";
import LayoutAdmin from "../components/LayoutAdmin";

import AdminReports from "../components/Admin/AdminReports";
import AdminUserDenied from "../components/Admin/AdminUserDenied";
import AdminUserPeding from "../components/Admin/AdminUserPeding";
import AdminUsers from "../components/Admin/AdminUsers";
import Notification from "../components/Notifications/Index";
import Group from "../pages/Company/Group";
import WrapperEventos from "./WrapperEventos";
import DetalleEvento from "../pages/Company/DetalleEvento";
import AdminInsignias from "../components/Admin/AdminInsignias";

import GroupsReport from "../components/Admin/Reportes/GroupsReport";
import VacantReport from "../components/Admin/Reportes/VacantReport";
import UsersReports from "../components/Admin/Reportes/UsersReports";
import AplicantsReport from "../components/Admin/Reportes/AplicantsReport";
import VacanteArea from "../components/Admin/Reportes/VacanteArea";

export const Wrapper = () => {
  const [applicantData, setApplicantData] = useState("");
  const [company, setcompany] = useState("");
  const [flag, setflag] = useState(false);
  const [role, roles] = useRoles();
  const history = useHistory();
  var [unreadNotificationCount, setUnreadNotificationCounter] = useState(0);
  var [notificationData, setNotificationData] = useState([])

  useOnceEffect(() => {

    axios.get("/notification").then((result) => {
      var notification = result.data

      if (notification != null) {

        setNotificationData(notification)
        notification.forEach(item => item.unread ? setUnreadNotificationCounter(unreadNotificationCount + 1) : null
        )



      }

    });


  })
  useOnceEffect(() => {
    const userId = localStorage.getItem("userId");

    const toastError =
      "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente";
    const toastConfig = {
      duration: 3000,
    };

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("tok")}`;

    const getApplicant = () => {
      if (!userId) return null;

      axios
        .get("access/applicant/" + userId)
        .then((result) => {
          if (result.status === 200) {
            setApplicantData(result.data.applicantProfile);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (e.response.status === 400) {
            history.push("/user/Perfil");
          } else {
            toast.error(toastError, toastConfig);
          }
        });
    };

    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    const getCompany = () => {
      axios
        .get("access/company/" + userId, config)
        .then((result) => {
          setcompany(result.data);
        })
        .catch(function (error) {
          if (!error.status) {
            toast.error(toast.error(toastError, toastConfig));
          } else if (error.response.status === 400) {
            toast.error(error.response.data.message);
          }
        });
    };

    const getCentro = () => {
      axios
        .get("access/company/" + userId, config)
        .then((result) => {
          setcompany(result.data);
        })
        .catch(function (error) {
          if (!error.status) {
            toast.error(toast.error(toastError, toastConfig));
          } else if (error.response.status === 400) {
            toast.error(error.response.data.message);
          }
        });
    };

    function getDefaultData() {
      switch (role) {
        case roles.ROLE_ADMIN:
          break;

        case roles.ROLE_APPLICANT:
          getApplicant()
          break;
        case roles.ROLE_COMPANY:
          getCompany()
          break;
        default:
          getCentro();
          break;
      }
    }


    getDefaultData()
  });

  function ReloadData() {
    setflag(flag ? false : true);
  }

  axios.interceptors.request.use(intersectorRequest);

  axios.interceptors.response.use(intersectorResponse, (e) =>
    intersectorError(e, history)
  );

  function AppRoutes() {
    switch (role) {
      case "applicant":
        return (
          <WrapperApplicant
            rol={role}
            ReloadData={ReloadData}
            applicantData={applicantData}
            unreadNotificationCount={unreadNotificationCount}
            functionCounter={setUnreadNotificationCounter}
            notificationData={notificationData && notificationData}
          />
        );
      case "company":
        return (
          <WrapperCompany rol={role} ReloadData={ReloadData} company={company} unreadNotificationCount={unreadNotificationCount} functionCounter={setUnreadNotificationCounter} notificationData={notificationData && notificationData} />
        );
      case "institute":
        return (
          <WrapperInstitute
            rol={role}
            ReloadData={ReloadData}
            company={company}
            unreadNotificationCount={unreadNotificationCount}
            notificationData={notificationData && notificationData}
            functionCounter={setUnreadNotificationCounter}
          />
        );

      case "admin":
        return <WrapperAdmin rol={role} ReloadData={ReloadData} functionCounter={setUnreadNotificationCounter} notificationData={notificationData} />;
      default:
        break;
    }
  }
  return (
  <div className="profile">
    {AppRoutes()}
  </div>);
};

function intersectorRequest(config) {
  let cancel = localStorage.getItem("cancel");
  if (cancel === "true") {
    return {
      ...config,
      cancelToken: new axios.CancelToken((cancel) =>
        cancel("Su sesion ha caducado")
      ),
    };
  } else {
    return config;
  }
}

function intersectorResponse(response) {
  localStorage.setItem("cancel", false);
  return response;
}

function intersectorError(error, history) {
  if (error.response) {
    if (error.response.status === 401) {
      if (localStorage.getItem("cancel") === "true") {
        toast.remove();
        toast.error("Su sesion ha caducado", { duration: 5000 });
        localStorage.clear();
        setTimeout(() => {
          history.push("/");
        }, 5000);
        throw new axios.Cancel("Operation canceled by the user.");
      } else {
        toast.remove();
        toast.error("Su sesion ha caducado", { duration: 5000 });
        localStorage.setItem("cancel", true);
        setTimeout(() => {
          history.push("/");
        }, 5000);
      }
    }
    localStorage.removeItem("cancel");
  } else if (error.response?.status) {
    toast.error(error.response.data.message);
  } else if (!error?.status) {
    toast.error(
      "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
      { duration: 3000 }
    );
  }
  return Promise.reject(error);
}

function WrapperCompany({ company, ReloadData, rol, unreadNotificationCount, functionCounter, notificationData }) {
  return (
    <Route path="/company/:path?">
      <Layout profile={company?.image} rol={rol} unreadNotificationCount={unreadNotificationCount}>
        <Switch>
          <PrivateRoute
            path="/company/chat"
            exact
            component={ChatPage}
          ></PrivateRoute>
          <PrivateRoute
            path="/company/notifications"
            exact
          >
            <Notification counter={functionCounter} notificationData={notificationData} />
          </PrivateRoute>
          <PrivateRoute path="/company/perfil" exact>
            <PerfilEmpresaEdit reload={ReloadData}></PerfilEmpresaEdit>
          </PrivateRoute>

          <PrivateRoute path="/company/Empresa/:id?">
            <Perfilempresa></Perfilempresa>
          </PrivateRoute>
          <PrivateRoute path="/company/Vacante">
            <WrapperVacante company={company}></WrapperVacante>
          </PrivateRoute>
          <PrivateRoute path="/company/Puesto/:id">
            <VistaVacante company={company}></VistaVacante>
          </PrivateRoute>
          <PrivateRoute path="/company/Candidato/:id?">
            <Candidato data={company}></Candidato>
          </PrivateRoute>
          <PrivateRoute
            path="/company/DetailVacant/:id"
            exact
            component={DetailVacant}
          ></PrivateRoute>
          <PrivateRoute path="/company/Formacion">
            <WrapperCursos company={company}></WrapperCursos>
          </PrivateRoute>
          <PrivateRoute path="/company/Eventos" >
            <WrapperEventos company={company}></WrapperEventos>
          </PrivateRoute>
          <PrivateRoute path="/company/DetalleEvento" exact>
            <DetalleEvento data={company}></DetalleEvento>
          </PrivateRoute>
          <PrivateRoute path="/company/DetalleCurso/:id?">
            <DetalleCurso data={company}></DetalleCurso>
          </PrivateRoute>
          <PrivateRoute
            path="/company/Home"
            exact
          >
            <HomeEmpresas data={company} />
          </PrivateRoute>
          <PrivateRoute
            path="/company/Conecta"
            exact
          >
            <ConectaEmpresa data={company}></ConectaEmpresa>
          </PrivateRoute>
          <PrivateRoute
            path="/company/Talento"
            exact
            component={Talento}
          ></PrivateRoute>

          <PrivateRoute path="/company/group-connect/:groupId" exact >
            <Group data={company} />
          </PrivateRoute>
        </Switch>
      </Layout>
    </Route>
  );
}

function WrapperInstitute({ rol, company, ReloadData, functionCounter, notificationData, unreadNotificationCount }) {
  return (
    <Route path="/CentroFormacion/:path?">
      <Layout profile={company?.image} rol={rol} unreadNotificationCount={unreadNotificationCount}>
        <Switch>
          <PrivateRoute path="/CentroFormacion/perfil" exact>
            <PerfilCentroEdit reload={ReloadData}></PerfilCentroEdit>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Formacion">
            <WrapperCursos company={company}></WrapperCursos>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Vacante">
            <WrapperVacante company={company}></WrapperVacante>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Home">
            <HomeCentro data={company}></HomeCentro>
          </PrivateRoute>
          <PrivateRoute
            path="/CentroFormacion/Conecta"
            exact
            component={Conecta}
          ></PrivateRoute>
          <PrivateRoute
            path="/CentroFormacion/notifications"
            exact
          >
            <Notification counter={functionCounter} notificationData={notificationData} />
          </PrivateRoute>
          <PrivateRoute
            path="/CentroFormacion/chat"
            exact
            component={ChatPage}
          ></PrivateRoute>
          <PrivateRoute path="/CentroFormacion/DetalleCurso/:id?" >
            <DetalleCurso data={company}></DetalleCurso>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Puesto/:id">
            <VistaVacanteCentro company={company}></VistaVacanteCentro>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Candidato/:id?">
            <CandidatoCentro></CandidatoCentro>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Empresa/:id?" >
            <PerfilEmpresaCentro></PerfilEmpresaCentro>
          </PrivateRoute>
          <PrivateRoute
            path="/CentroFormacion/Talento"
            exact
            component={Talento}
          ></PrivateRoute>

          <PrivateRoute path="/CentroFormacion/group-connect/:groupId" exact >
            <Group data={company} />
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/Eventos" >
            <WrapperEventos company={company}></WrapperEventos>
          </PrivateRoute>
          <PrivateRoute path="/CentroFormacion/DetalleEvento" exact>
            <DetalleEvento data={company}></DetalleEvento>
          </PrivateRoute>
        </Switch>
      </Layout>
    </Route>
  );
}

function WrapperApplicant({ applicantData, rol, ReloadData, company, functionCounter, notificationData, unreadNotificationCount }) {
  return (
    <Route path="/user/:path?">
      <Layout profile={applicantData?.image} rol={rol} unreadNotificationCount={unreadNotificationCount}>
        <Switch>
          <PrivateRoute
            path="/user/chat"
            exact
            component={ChatPage}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/notifications"
            exact
          >
            <Notification counter={functionCounter} notificationData={notificationData} />
          </PrivateRoute>
          <Route path="/user/perfil" exact>
            <Perfil reload={ReloadData}></Perfil>
          </Route>
          <Route path="/user/Empleos" exact>
            <Empleos></Empleos>
          </Route>
          <PrivateRoute path="/user/DetalleEvento" exact>
            <DetalleEvento data={company}></DetalleEvento>
          </PrivateRoute>
          <PrivateRoute
            path="/user/Vacante/:id"
            component={Vacante}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/PerfilEmpresa/:id?"
            exact
            component={PerfilEmpresa}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/Conecta"
            exact
            component={Conecta}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/Aplicados"
            exact
            component={Aplicados}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/Guardados"
            exact
            component={Guardados}
          ></PrivateRoute>
          <PrivateRoute
            path="/user/Formacion"
            exact
            component={Formacion}
          ></PrivateRoute>
          <PrivateRoute path="/user/Home" exact component={Home}></PrivateRoute>
          <PrivateRoute
            path="/user/DetalleCurso/:id"
            exact
            component={DetalleCursoAplic}
          ></PrivateRoute>
          <PrivateRoute path="/user/Candidato/:id?">
            <Candidato data={company}></Candidato>
          </PrivateRoute>
          <PrivateRoute
            path="/user/BusquedaEmpleos"
            exact
            component={BusquedaEmpleos}
          ></PrivateRoute>


          <PrivateRoute path="/user/group-connect/:groupId" exact >
            <Group data={applicantData} />
          </PrivateRoute>
        </Switch>
      </Layout>
    </Route>
  );
}

function WrapperAdmin({ rol, ReloadData }) {
  return (
    <Route path="/admin/:path?">
      <LayoutAdmin rol={rol}>
        <PrivateRoute path="/admin/home" component={AdminHome} exact />

        <PrivateRoute path="/admin/users" component={AdminUsers} exact />
        <PrivateRoute path="/admin/users/pending" component={AdminUserPeding} exact />
        <PrivateRoute path="/admin/users/denied" component={AdminUserDenied} exact />
        <PrivateRoute path="/admin/reports" component={AdminReports} exact />
        <PrivateRoute path="/admin/insignias" component={AdminInsignias} exact />
        
        <PrivateRoute path="/admin/groupsreport" component={GroupsReport} exact />
        <PrivateRoute path="/admin/vacantreport" component={VacantReport} exact />
        <PrivateRoute path="/admin/usersreports" component={UsersReports} exact />
        <PrivateRoute path="/admin/aplicantsreport" component={AplicantsReport} exact />
        <PrivateRoute path="/admin/vacantearea" component={VacanteArea} exact />

        {/* Perfiles de los usuarios */}
        <PrivateRoute path="/admin/perfil/company" exact>
          <PerfilEmpresaEdit reload={ReloadData}></PerfilEmpresaEdit>
        </PrivateRoute>

        <PrivateRoute path="/admin/perfil/applicant" exact>
          <Perfil reload={ReloadData}></Perfil>
        </PrivateRoute>

        <PrivateRoute path="/admin/perfil/formacion" exact>
          <PerfilCentroEdit reload={ReloadData}></PerfilCentroEdit>
        </PrivateRoute>
      </LayoutAdmin>
    </Route>
  );
}
export default Wrapper;
